function colorElements() {
  const productItems = document.querySelectorAll('.product-card-wrapper');
  if (productItems) {
    productItems.forEach((productItem, index) => {
      const whProMetaH3 = productItem.querySelector('.render-color-cs');
      if (whProMetaH3 && !whProMetaH3.dataset.colorAppended) {
        const productUrl = productItem.querySelector('.cardproduct-title').getAttribute('data-href');
        fetch(productUrl)
        .then(response => response.text())
        .then(data => {
          const parser = new DOMParser();
          const htmlDocument = parser.parseFromString(data, 'text/html');

          const productcolorCs = htmlDocument.querySelector('.cs-local-srtg');
          if (productcolorCs) {
            const colorElement = document.createElement('div');
            colorElement.className = 'tw-flex tw-flex-row tw-flex-nowrap';
            colorElement.innerHTML = productcolorCs.innerHTML;
            whProMetaH3.appendChild(colorElement);
            whProMetaH3.dataset.colorAppended = true;
          }
        })
        .catch(error => {
          console.error(error);
        });
      }
    });
  }
}
window.onload = (event) => {
colorElements();
};


